import { ContractsDialogSuccess } from "@/components/contracts/modals/contracts-dialog-success"
import {
  SherpaDialog,
  SherpaDialogContent,
} from "@/components/ui-kit/dialog"

export function AdvancePaySuccessDialog({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <SherpaDialog open={open} onOpenChange={onOpenChange}>
      <SherpaDialogContent className="max-sm:left-0 max-sm:h-auto max-sm:max-h-[95dvh] max-sm:w-full max-sm:max-w-none max-sm:translate-x-0 h-auto pt-8 sm:pt-10">
        <ContractsDialogSuccess
          title={"Выставим счет \n в течение дня"}
          description={
            "Сотрудники проверят заявку, и счет появится на сайте.\n А на почту придет сообщение с файлом счета."
          }
          iconWrapperClassName="pt-0"
          onClose={() => onOpenChange(false)}
        />
      </SherpaDialogContent>
    </SherpaDialog>
  )
}

export type AdvancePayNavigationState = {
  showAdvancePaySuccess?: boolean
}
